"use client";

import { trackDataDogAction } from "@/lib/analytics/trackDataDogAction";

type LanguageContext = { language: string };

export function trackWorkshopRegistrationViewed(
  workshopId: number,
  { language }: LanguageContext,
): void {
  trackDataDogAction("workshops:registration:viewed", {
    workshopId,
    language,
  });
}

export function trackWorkshopRegistrationFormStarted(
  workshopId: number,
  { language }: LanguageContext,
): void {
  trackDataDogAction("workshops:registration_form:started", {
    workshopId,
    language,
  });
}

export function trackWorkshopRegistrationSubmitted(
  workshopId: number,
  { language }: LanguageContext,
): void {
  trackDataDogAction("workshops:registration:submitted", {
    workshopId,
    language,
  });
}

export function trackWorkshopRegistrationFailed(
  workshopId: number,
  { language, reason }: LanguageContext & { reason: string },
): void {
  trackDataDogAction("workshops:registration:failed", {
    workshopId,
    language,
    reason,
  });
}

export function trackWorkshopRegistrationClosed(
  workshopId: number,
  { language }: LanguageContext,
): void {
  trackDataDogAction("workshops:registration:closed", {
    workshopId,
    language,
  });
}

export function trackWorkshopRecordingViewed(workshopId: number): void {
  trackDataDogAction("workshops:recording:viewed", { workshopId });
}

export function trackWorkshopShared(
  workshopId: number,
  channel: "email" | "sms" | "link",
): void {
  trackDataDogAction("workshops:workshop:shared", { workshopId, channel });
}

export function trackWorkshopCreateFormSubmitted(eventType: string): void {
  trackDataDogAction("workshops:create_form:submitted", { eventType });
}

export function trackWorkshopCreateFormFailed(
  eventType: string,
  reason: string,
): void {
  trackDataDogAction("workshops:create_form:failed", { eventType, reason });
}

export function trackWorkshopPublished(
  workshopId: number,
  eventType: string,
): void {
  trackDataDogAction("workshops:workshop:published", { workshopId, eventType });
}

export function trackWorkshopCancelled(
  workshopId: number,
  eventType: string,
): void {
  trackDataDogAction("workshops:workshop:cancelled", { workshopId, eventType });
}

export function trackWorkshopZoomSessionRetried(workshopId: number): void {
  trackDataDogAction("workshops:zoom_session:retried", { workshopId });
}

export function trackWorkshopAttendeeLogExported(workshopId: number): void {
  trackDataDogAction("workshops:attendee_log:exported", { workshopId });
}

export function trackWorkshopParticipantsTabViewed(workshopId: number): void {
  trackDataDogAction("workshops:participants_tab:viewed", { workshopId });
}

export function trackWorkshopStatsTabViewed(workshopId: number): void {
  trackDataDogAction("workshops:stats_tab:viewed", { workshopId });
}

export function trackWorkshopDetailPanelOpened(workshopId: number): void {
  trackDataDogAction("workshops:detail_panel:opened", { workshopId });
}

export function trackWorkshopRecordingLinkClicked(workshopId: number): void {
  trackDataDogAction("workshops:recording_link:clicked", { workshopId });
}

export function trackWorkshopValidationErrorShown(
  workshopId: number,
  { fields }: { fields: string[] },
): void {
  trackDataDogAction("workshops:validation_error:shown", {
    workshopId,
    fields,
  });
}

export function trackWorkshopPrivateLinkAccessed(workshopId: number): void {
  trackDataDogAction("workshops:private_link:accessed", { workshopId });
}

export function trackWorkshopRecordingAccessFormSubmitted(
  workshopId: number,
): void {
  trackDataDogAction("workshops:recording_access_form:submitted", {
    workshopId,
  });
}

export function trackWorkshopRecordingAccessFormFailed(
  workshopId: number,
  reason: string,
): void {
  trackDataDogAction("workshops:recording_access_form:failed", {
    workshopId,
    reason,
  });
}

export function trackWorkshopRecordingPlayerLoaded(workshopId: number): void {
  trackDataDogAction("workshops:recording_player:loaded", { workshopId });
}
